module.exports = __webpack_public_path__ + "static/media/gestoria-tickets-rojo.e0d3b14c.svg";